import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/features/feature-image-2-hq.webp")